import { render, staticRenderFns } from "./m-roster-orgs.vue?vue&type=template&id=04e6d080&scoped=true&"
import script from "./m-roster-orgs.ts?vue&type=script&lang=ts&"
export * from "./m-roster-orgs.ts?vue&type=script&lang=ts&"
import style0 from "./m-roster-orgs.scss?vue&type=style&index=0&id=04e6d080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e6d080",
  null
  
)

export default component.exports